import { ReactElement } from 'react'
import AntProvider from './antd'

export default function Providers({ children }: { children: ReactElement }) {
  return <AntProvider>{children}</AntProvider>
}
